import React, { PureComponent } from 'react'
import { t } from '../../helpers/localization'
import '../../styles/leaflet.scss'
import styles from './ViewSupply.scss'

export type ICloseDialogButton = {
    onClick: () => void
}

class CloseDialogButton extends PureComponent<ICloseDialogButton, any> {
    render() {
        return (
            <div className={styles.closeDialogButtonWrapper}>
                <div className={styles.closeDialogButton} onClick={this.props.onClick}>
                    <div className={styles.closeDialogButtonIcon} />
                    <span className={styles.closeDialogButtonText}>{t('Закрыть')}</span>
                </div>
            </div>
        )
    }
}

export default CloseDialogButton